module.exports = __webpack_public_path__ + "static/FemaleDoctorDarkHair.6bf87ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/FemaleDoctorDarkHair.png
// module id = ./src/media/FemaleDoctorDarkHair.png
// module chunks = 2488159010210823000